import React, { FC, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "src/components/buttons";
import { Page, PageHero, Spinner } from "src/components/common";
import CourseCard from "./CourseCard";
import { useApi } from "src/Api/useApi";
import { TrainingCourse } from "src/@types/ImpiricaPlatformApi";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";
import { AdminPermissions } from "src/common/Permissions";

interface TrainingManagementPageProps {
	history?: any;
	location?: any;
	match?: any;
	children?: any;
}

const TrainingManagementPage: FC<TrainingManagementPageProps> = ({
	history,
	location,
	match,
	children,
}) => {
	const { trainingCourseClient } = useApi();
	const [courseList, setCourseList] = React.useState<TrainingCourse[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const [showInactive, setShowInactive] = React.useState<boolean>(false);

	useEffect(() => {
		if (trainingCourseClient) {
			_loadData();
		}
	}, [trainingCourseClient]);

	const _loadData = async () => {
		try {
			setLoading(true);
			if (trainingCourseClient) {
				try {
					const response = await trainingCourseClient.getAllTrainingCourses();
					setCourseList(response);
				} catch (error) {
					console.error(error);
					throw error;
				}
			}
		} finally {
			setLoading(false);
		}
	};

	const onShowAllClick = () => {
		setShowInactive(!showInactive);
	};

	const coursesToShow = useMemo(() => {
		return showInactive
			? courseList
			: courseList.filter((course) => course.isActive);
	}, [courseList, showInactive]);

	return loading ? (
		<Spinner />
	) : (
		<Page>
			<PageHero>
				<Link to="/admin/organizations">&lt; ORGANIZATIONS</Link>
				<h1 className="mb-0">Training Course Management</h1>
			</PageHero>
			<AuthorizationWrapper
				type="hide"
				permissions={[AdminPermissions.GlobalAdmin]}
			>
				<div className="container-fluid">
					<div className="d-flex mb-4">
						<div className="ml-auto">
							<Button onClick={onShowAllClick} className="btn-primary mr-3">
								{showInactive ? "Show Active" : "Show All"}
							</Button>
							<Button to={"/admin/training/-1"} className="btn-primary">
								Add Course
							</Button>
						</div>
					</div>
					<div className="d-flex justify-content-center row align-items-center">
						{coursesToShow.length > 0 ? (
							coursesToShow.map((course) => (
								<CourseCard
									key={course.id}
									id={course.id}
									img={course.imageUrl}
									title={course.title}
									description={course.description}
								/>
							))
						) : (
							<div>No courses found</div>
						)}
					</div>
				</div>
			</AuthorizationWrapper>
		</Page>
	);
};

export default TrainingManagementPage;
